import React from 'react';

export enum WizardStep {
  input = 'input',
  submit = 'submit',
  submitting = 'submitting',
  success = 'success',
  failure = 'failure',
  conflict = 'conflict',
}

const transitions = {
  [WizardStep.input]: [WizardStep.submit],
  [WizardStep.submit]: [WizardStep.input, WizardStep.submitting],
  [WizardStep.submitting]: [
    WizardStep.success,
    WizardStep.failure,
    // Conflict means submission failed because user already submitted
    WizardStep.conflict,
  ],
  // Failure has the same next steps as submit to allow retrying
  [WizardStep.failure]: [WizardStep.input, WizardStep.submitting],
  [WizardStep.success]: [],
  // Conflict is an end state like success
  [WizardStep.conflict]: [],
};

export function useWizard() {
  const [currStep, setStep] = React.useState(WizardStep.input);

  function stepFromTo(fromStep: WizardStep, toStep: WizardStep | null) {
    const validNextSteps: WizardStep[] = transitions[fromStep];
    if (toStep != null && validNextSteps.includes(toStep)) {
      setStep(toStep);
    }
  }

  return [currStep, stepFromTo] as const;
}
